import {useAiChat} from '@/ai-chat/providers/ai-chat.context';
import {LoadingStates} from '@Utils/loading.util';
import {closeAiActionLoadingModal} from '@Components/ai-chat-window/lib/ai-action-loading-modal.library';
import {GA4EventName} from '@Libraries/ga-events';

interface UseOpenChatImageInEditor {
  openPosterInEditor: (chatId: string, hashedId: string) => Promise<void>;
}

export const useOpenChatImageInEditor = (): UseOpenChatImageInEditor => {
  const {actions} = useAiChat();

  const openPosterInEditor = async (chatId: string, hashedId: string): Promise<void> => {
    window.open(window.PMW.util.site_url(`posterbuilder/loadFromAiChatImage/${hashedId}`), '_blank');
    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_OPEN_EDITOR);

    actions.updateLoadingStatesForImageActions(chatId, hashedId, {
      openEditorLoadingState: LoadingStates.LOADING,
    });

    try {
      window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_OPEN_EDITOR);
      actions.updateLoadingStatesForImageActions(chatId, hashedId, {
        openEditorLoadingState: LoadingStates.LOADED,
      });
    } catch (e: unknown) {
      actions.updateLoadingStatesForImageActions(chatId, hashedId, {
        openEditorLoadingState: LoadingStates.NOT_LOADED,
      });
      closeAiActionLoadingModal();
      console.error(e);
    }
  };

  return {openPosterInEditor};
};
